import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const client = axios.create({
  baseURL: API,
  headers: { 'Content-Type': 'application/json' },
  timeout: 20000,
});

export async function postJson(path, body) {
  const res = await client.post(path, body);
  return res.data;
}

export async function getJson(path) {
  const res = await client.get(path);
  return res.data;
}

export default client;
